// extracted by mini-css-extract-plugin
export default {"ingredientItem":"ConstructorList_ingredientItem__lvPEw","ingredientElement":"ConstructorList_ingredientElement__55As+"};